import React from 'react';
import './overlap-with-filters.styles.scss';

export const OverlapWithFilter = props => {
  return <div className='overlap-box-with-filters'>{props.children}</div>;
};
